<!-- <app-search-header searchBarType="opened"></app-search-header> -->
<div>
  <div style="padding: 20px">
    <a class="qa-header" href="/signin">signin</a>
  </div>
</div>
